<template>
  <div class="captcha-input" :class="{ 'captcha-input__h5': isH5 }">
    <el-input
      v-for="(item, index) in captchaLength"
      :key="index"
      :ref="'captchaInput' + index"
      v-model="captchaCode[index]"
      :disabled="disabled"
      class="input login-input-code"
      maxlength="7"
      inputmode="numeric"
      @input="handleInput(index, $event)"
      @keydown.native.backspace="onBackspacekeydown(index, $event)"
      @keyup.native.backspace="onBackspace(index, $event, captchaCode[index])"
    />
  </div>
</template>

<script>
import { isH5 } from "@saas/components/src";
import { uploadLiveLog } from "@saas/components/src/utils/log";
export default {
  props: {
    captchaLength: {
      type: Number,
      default: 6,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      captchaCode: Array(6).fill(""),
      isH5: isH5(),
      deleteBeforeValue: Array(6).fill(""),
    };
  },
  mounted() {
    // 自动聚焦到第一个输入框
    this.$nextTick(() => {
      this.$refs.captchaInput0[0].focus();
    });
  },
  methods: {
    handleKeydown(e) {
      let key = e.key;
      const keys = [".", "-", "+", "e", "E"];
      if (keys.includes(key)) {
        e.returnValue = false;
        return false;
      } else {
        return true;
      }
    },
    resetEmpty() {
      this.captchaCode = Array(6).fill("");
    },
    handleInput(index, val) {
      if (String(val).length === 6) {
        // 把6位验证码分别填入验证码6个输入框
        this.captchaCode[0] = val.slice(0, 1);
        this.captchaCode[1] = val.slice(1, 2);
        this.captchaCode[2] = val.slice(2, 3);
        this.captchaCode[3] = val.slice(3, 4);
        this.captchaCode[4] = val.slice(4, 5);
        this.captchaCode[5] = val.slice(5, 6);
        this.focusNextInput(4);
        this.$emit("inputOver", val);
        return;
      }
      // 首先过滤掉非数字的字符，包括e
      val = val.replace(/[^0-9]/g, "");
      // 如果val长度大于1，则取第一个字符
      val = val.slice(0, 1);
      this.captchaCode[index] = val;

      // 当用户输入一个字符后自动跳转到下一个输入框
      if (val && val.length === 1) {
        this.focusNextInput(index);
      }

      // 检查是否已完整输入验证码并触发验证逻辑
      if (this.isCaptchaComplete()) {
        this.validateCaptcha(this.captchaCode.join(""));
      }
    },
    focusNextInput(currentIndex) {
      const nextIndex = currentIndex + 1;
      if (nextIndex < this.captchaLength) {
        this.$refs["captchaInput" + nextIndex][0].focus();
      } else {
        this.$refs["captchaInput" + currentIndex][0].blur();
      }
    },
    isCaptchaComplete() {
      return this.captchaCode.every((item) => item.length === 1);
    },
    validateCaptcha(captcha) {
      // 上传日志：验证码输入完成
      uploadLiveLog({
        message: "验证码输入完成",
        module: "login",
        level: "info",
        tag: "userAction",
        extra: {
          component: "InputNum",
          captchaLength: captcha.length,
        },
      }, true);
      
      this.$emit("inputOver", captcha);
    },
    onBackspacekeydown(index, event) {
      this.deleteBeforeValue[index] = event.target.value;
    },
    onBackspace(index, event) {
      const input = event.target;
      if (!this.deleteBeforeValue[index]) {
        const prevIndex = index - 1;
        if (prevIndex >= 0) {
          this.$refs["captchaInput" + prevIndex][0].focus();
          this.$set(this.captchaCode, prevIndex, "");
        }
      } else {
        this.captchaCode[index] = "";
        this.deleteBeforeValue[index] = "";
      }
    },
  },
};
</script>

<style scoped lang="scss">
.captcha-input ::v-deep {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  .input {
    width: 50px;
    height: 50px;
    .el-input__inner {
      padding-right: 0;
      width: 50px;
      height: 50px;
      line-height: 50px;
      border-radius: 12px;
      padding: 0;
      text-align: center;
      font-weight: 400;
      font-size: 18px;
      color: $saas-text-color;
      &:focus {
        border-color: #00c89d;
      }
    }
  }
}
.captcha-input__h5 ::v-deep {
  width: 100%;
  .input {
    width: 1.0667rem;
    height: 1.0667rem;
    .el-input__inner {
      padding-right: 0;
      width: 1.0667rem;
      height: 1.0667rem;
      line-height: 1.0667rem;
      border-radius: 0.2133rem;
      font-size: 0.4267rem;
    }
  }
}
</style>
<style lang="scss">
.login-input-code {
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
  }
  input[type="number"] {
    -moz-appearance: textfield;
  }
}
</style>
